import { useEffect, useState } from 'react';
import PageHeader from '../../components/PageHeader';
import { MISSION } from '../../config/data';
import { t, isOverseas } from '../../utils/i18n';
import './index.css';

const CONTACTS = [
    { label: t('产业合作', 'Industry Partnerships'), email: 'contact@iquestlab.com' },
    { label: t('学术合作', 'Academic Partnerships'), email: 'research@iquestlab.com' },
    { label: t('公共关系', 'Public Relations'), email: 'PR@iquestlab.com' },
    { label: '', email: '' },
    { label: '', email: '' },
    { label: '', email: '' },
    { label: '', email: '' },
    { label: '', email: '' },
];

const COMPANY = {
    name: t('北京至知科技有限公司', 'Beijing Zhizhi Technology Co., Ltd.'),
    address: t(
        '北京市海淀区中关村东路 1 号院 8 号楼三层 B201',
        'Room B201, 3F, Building 8, No. 1 Zhongguancun East Road, Haidian District, Beijing, China'
    ),
    postalCode: '100084',
};

export default function TeamPage() {
    const [mapLoaded, setMapLoaded] = useState(false);

    useEffect(() => {
        document.title = t('关于我们 · 至知创新研究院', 'About Us · IQuest Research');
    }, []);

    useEffect(() => {
        let map;
        function initMap() {
            if (!window.AMap) return;
            map = new window.AMap.Map('contact-amap', {
                zoom: 15,
                center: [116.330352, 39.993927],
                mapStyle: 'amap://styles/normal',
                lang: isOverseas ? 'en' : 'zh_cn',
                dragEnable: false,
                scrollWheel: true,
            });
            // 缩放后强制将坐标点回到视野中心
            map.on('zoomend', function () {
                map.setCenter([116.330352, 39.993927]);
            });
            new window.AMap.Marker({
                position: [116.330352, 39.993927],
                map: map,
                icon: new window.AMap.Icon({
                    size: new window.AMap.Size(25, 34),
                    image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png',
                    imageSize: new window.AMap.Size(25, 34),
                }),
                offset: new window.AMap.Pixel(-12, -34),
            });

            const infoContent = `
                <div class="contact-company-card-info">
                    <h4 class="contact-company-name">${COMPANY.name}</h4>
                    <p class="contact-company-line">${t('地址：', 'Address: ')}${COMPANY.address}</p>
                    <p class="contact-company-line">${t('邮编：', 'Postal Code: ')}${COMPANY.postalCode}</p>
                </div>
            `;
            const infoWindow = new window.AMap.InfoWindow({
                content: infoContent,
                offset: new window.AMap.Pixel(0, -40),
                isCustom: true,
            });
            infoWindow.open(map, [116.330352, 39.993927]);

            setMapLoaded(true);
        }

        if (window.AMap) {
            initMap();
        } else {
            // 等待脚本加载
            const timer = setInterval(() => {
                if (window.AMap) {
                    clearInterval(timer);
                    initMap();
                }
            }, 200);
            return () => clearInterval(timer);
        }

        return () => { if (map) map.destroy(); };
    }, []);

    return (
        <div className="page-shell">
            <PageHeader
                eyebrow="About"
                title={t('关于我们', 'About Us')}
                subtitle={t('做更有价值的AI。', 'AI delivers more.')}
            />

            {/* ============ Mission Section ============ */}
            <section className="section team-mission-section">
                <div className="container">
                    <div className="team-mission-card">
                        <div className="eyebrow">{t('企业愿景与使命', 'Mission & Vision')}</div>
                        <p className="team-mission-desc">{MISSION.desc}</p>
                    </div>
                </div>
            </section>

            {/* ============ Contact Section ============ */}
            <section className="section team-contact-section" id="contact">
                <div className="container">
                    {/* 邮箱网格 */}
                    <div className="contact-emails">
                        {CONTACTS.map((item, idx) => (
                            <div className="contact-email-item" key={idx}>
                                <span className="contact-email-label">{item.label || '\u00A0'}</span>
                                <span className="contact-email-addr">
                                    {item.email || '\u00A0'}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 地图 + 公司信息（全宽） */}
                <div className="contact-map-wrapper">
                    <div id="contact-amap" className="contact-map"></div>
                    {!mapLoaded && (
                        <div className="contact-company-card is-centered">
                            <h4 className="contact-company-name">{COMPANY.name}</h4>
                            <p className="contact-company-line">
                                <span className="contact-company-label">{t('地址：', 'Address: ')}</span>
                                {COMPANY.address}
                            </p>
                            <p className="contact-company-line">
                                <span className="contact-company-label">{t('邮编：', 'Postal Code: ')}</span>
                                {COMPANY.postalCode}
                            </p>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}
